import { render } from "./natureSummary.vue?vue&type=template&id=321f4736&scoped=true"
import script from "./natureSummary.vue?vue&type=script&lang=js"
export * from "./natureSummary.vue?vue&type=script&lang=js"

import "./natureSummary.vue?vue&type=style&index=0&id=321f4736&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321f4736"],['__file',"src/views/data/components/daliyReport/natureSummary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "321f4736"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('321f4736', __exports__)) {
    console.log('reload')
    api.reload('321f4736', __exports__)
  }
  
  module.hot.accept("./natureSummary.vue?vue&type=template&id=321f4736&scoped=true", () => {
    console.log('re-render')
    api.rerender('321f4736', render)
  })

}


export default __exports__